// utils/logger.js
export function devLog(...args) {
	if (import.meta.env.MODE === "development") {
		console.log(...args);
	}
}

export function devErrLog(...args) {
	if (import.meta.env.MODE === "development") {
		console.error(...args);
	}
}

export function devWarnLog(...args) {
	if (import.meta.env.MODE === "development") {
		console.warn(...args);
	}
}